let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("78zGn")).then(() => parcelRequire('7skWy'));